<template>
  <ResetPassForm :is-loading="isLoading" :on-submit="resetPassword" />
</template>

<script>
  import ResetPassForm from '../../components/forms/auth/SetPass';

  export default {
    components: {
      ResetPassForm,
    },
    data() {
      return {
        isLoading: false,
        langBoxPos: {
          top: 10,
          right: 10,
        },
      };
    },
    methods: {
      resetPassword(password) {
        const { token } = this.$route.params;
        const { email } = this.$store.getters['auth/user'];

        const query = {
          token,
          email,
          password,
        };

        this.isLoading = true;

        this.$store
          .dispatch('auth/resetPass', query)
          .then((res) => {
            this.isLoading = false;
            return res;
          })
          .catch((err) => {
            this.isLoading = false;
            return err;
          });
      },
    },
    metaInfo() {
      return {
        title: this.$t('views_reset_second_title'),
      };
    },
  };
</script>
